import React, { useEffect } from 'react'
import { assetDropdown } from "./Dropdowns";
import {
  CheckBoxSelection,
  Inject,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns";
import _ from "lodash";
import * as liveViewAction from "../../../infofleet/ducks/liveView";
import { useDispatch } from "react-redux";
import { serverurl } from "../../router/config";
import api from '../../router/axiosConfig';

function SelectDriverDropdown(props) {
  const { handleAssetChange } = props;
  const [assetDropDown, setAssetDropDown] = React.useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    getAssetData();
  }, [])

  const getAssetData = async () => {
    const res = await assetDropdown();
    setAssetDropDown(res.data.items);
  };

  // Multiselect Box
  const assetarray = assetDropDown !== "" && assetDropDown !== undefined ?
    assetDropDown.filter(function (obj) {
      return obj.type === "child";
    }) : "";

  const assetchange = _.debounce(async (event) => {
    const selectedValues = event.value || [];
    const totalItems = assetarray.length;
    const previousCount = event.oldValue?.length || 0;

    const isSelectAll =
      event.isInteracted &&
      selectedValues.length === totalItems &&
      previousCount !== totalItems;

    const isDeselectAll =
      event.isInteracted &&
      selectedValues.length === 0 &&
      previousCount === totalItems;

    if (isSelectAll) {
      console.log("✅ Select All clicked");
    } else if (isDeselectAll) {
      console.log("❌ Deselect All clicked");
    } else if (event.isInteracted) {
      console.log("➡️ Individual item selected/unselected");
    }

    // Handle API logic only for relevant cases
    if (isDeselectAll) {
      // clear state or handle accordingly
      handleAssetChange(false, []);
      dispatch(liveViewAction.actions.filterData([]));
      return;
    }

    if (selectedValues.length === 0) {
      handleAssetChange(false, []);
      return;
    }

    // Proceed with single API call for all selected values
    const SERVICE_URL = `${serverurl}getLiveStatusData`;
    const requestBody = { vehicleIds: _.toString(selectedValues) };

    try {
      const response = await api.post(SERVICE_URL, requestBody, {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        withCredentials: true,
      });
      if (response.data && response.data[0]?.items) {
        dispatch(liveViewAction.actions.filterData(response.data[0].items));
      }

      handleAssetChange(true, selectedValues);
    } catch (error) {
      console.error("Error fetching live status data:", error);
    }
  }, 400); //debounce - 400 It prevents duplicate API calls.
  // Asset Chnage Function

  const asset_fields = {
    groupBy: "groupname",
    text: "name",
    value: "vehicleId",
  };
  return (
    <MultiSelectComponent
      id="mtselement"
      popupHeight="500px"
      popupWidth="350px"
      fields={asset_fields}
      dataSource={assetarray}
      placeholder="Select by ID/Plate/Driver"
      mode="CheckBox"
      enableGroupCheckBox="true"
      filterType="Contains"
      allowFiltering="true"
      change={assetchange}
      changeOnBlur={false}
      showSelectAll="true"
      cssClass="col-md-10 p_0 mb_0 mt_5"
    >
      <Inject services={[CheckBoxSelection]} />
    </MultiSelectComponent>

  )
}
export default SelectDriverDropdown;